import form from "./form/index";

const quoteComponents = {
    form
}

export default quoteComponents;